// extracted by mini-css-extract-plugin
export var textInput = "_ch-0";